import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Card from 'components/inputs/Card';
import { MdClose } from 'react-icons/md';
import { Row, Col } from 'react-bootstrap';
import { Formik, Form } from 'formik';
import TextInput from 'components/inputs/Input';
import Button from 'components/inputs/Button';
import _ from 'lodash';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { CREATE_TAGS, UPDATE_TAGS } from 'actions/tagmanagement';
import { CREATE_STATUS_CODE, UPDATE_STATUS_CODE } from 'components/common/constant';
import { useTranslation } from 'react-i18next';

const TagSchema = Yup.object().shape({
  name: Yup.string(),
});

const Tagsform = (props) => {
  const { t } = useTranslation();
  const { isEdit, onClose = _.noop(), onSuccess = _.noop() } = props;
  const dispatch = useDispatch();

  const tagsDetail = useSelector((state) => state.tagmanagement.tagsDetails);
  console.log(tagsDetail, '--');
  const isLoading = useSelector((state) => state.tagmanagement.isLoading);

  const addTags = useCallback((data) => {
    dispatch({
      type: CREATE_TAGS.REQUEST,
      payload: data,
      cb: (res) => {
        if (_.get(res, 'status') === CREATE_STATUS_CODE) {
          onSuccess();
          onClose();
        }
      },
    });
  }, []);

  const updateTags = useCallback((data) => {
    dispatch({
      type: UPDATE_TAGS.REQUEST,
      payload: data,
      cb: (res) => {
        if (_.get(res, 'status') === UPDATE_STATUS_CODE) {
          onClose();
        }
      },
    });
  }, []);

  const initialValues = isEdit
    ? { ...tagsDetail }
    : {
        name: '',
      };
  return (
    <React.Fragment>
      <div className="chargerState-form-page__main">
        <Card>
          <div className="chargerState-form-header__block">
            <div className="chargerState-header-name">
              <span>
                {isEdit ? 'Edit' : 'Add'} {t('placeHolder.tags')}
              </span>
            </div>
            <div className="close___btn">
              <MdClose size={30} color="#be210b" onClick={onClose} />
            </div>
          </div>
          <div className="chargerState-form-body__block">
            <div className="chargerState-form--block">
              <Formik
                enableReinitialize={!!isEdit}
                initialValues={initialValues}
                validationSchema={TagSchema}
                onSubmit={(values, { setSubmitting }) => {
                  if (isEdit) {
                    updateTags(values);
                  } else {
                    addTags(values);
                  }
                  setSubmitting(false);
                }}
              >
                {({ values, errors, touched, handleSubmit, handleChange, isSubmitting }) => (
                  <Form onSubmit={handleSubmit}>
                    <Row>
                      <Col>
                        <TextInput
                          isRequired
                          label={t('tagManagement.tagName')}
                          placeholder={t('tagManagement.name')}
                          name="name"
                          value={_.get(values, 'name', '')}
                          onChange={handleChange}
                          error={errors.name && touched.name ? errors.name : null}
                        />
                      </Col>
                    </Row>
                    <div className="form-btn__block">
                      <Button className="form_btn cancel____btn" onClick={onClose}>
                        {t('button.cancel')}
                      </Button>
                      <Button type="submit" disabled={isSubmitting || isLoading} className="form_btn">
                        {isEdit ? 'Edit' : 'Add'}
                      </Button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </Card>
      </div>
    </React.Fragment>
  );
};
Tagsform.propTypes = {
  onSuccess: PropTypes.func,
  onClose: PropTypes.func,
  isEdit: PropTypes.bool,
};
export default Tagsform;
